// 搜索栏获取参数
class searchReq {
    public pageNo: number;
    public pageSize: number;               
    public startDate: string;   
    public university: string;
    public getTimeBegin: string;
    public getTimeEnd: string;
    public executeState: string;

    constructor(){
        this.pageNo = 1;
        this.pageSize = 20;
        this.startDate = '';
        this.university = '';
        this.getTimeBegin = '';
        this.getTimeEnd = '';
        this.executeState = '1';
    }
}

// 新增或修改申请单参数
class addFormReq {
    public id: any;
    public pointId: string;           
    public code: string;   
    public score: string;
    public remark: string;
    public type: string;
    public personId: string;           
    public personCode: string;   
    public personName: string;
    public year: string;
    public modifierTime : string;
    public personModifierTime : string;
    public getTime : string;

    constructor(){
        this.remark = '';
        this.type = '';
        this.pointId = ''; 
        this.code = '';
        this.year = '';
        this.score = '';
        this.modifierTime = '';
        this.personCode = '';
        this.personName = '';
        this.getTime = '';
        this.id = '';
        this.personId = '';
        this.personModifierTime = '';
    }
}
// 新增行程参数
class addFormData {
    public speechTime: any;
    public university: string;           
    public address: string;   
    public place: string;
    public regulation: string;
    public startDate: any;
    public expectationNumber: any;

    constructor(){
        this.speechTime = '';
        this.university = '';
        this.address = ''; 
        this.place = '';
        this.regulation = '';
        this.startDate = '';
        this.expectationNumber = '';
    }
}
// 编辑行程参数
class editFormData {
    public id: any;
    public speechTime: any;
    public university: string;           
    public address: string;   
    public place: string;
    public regulation: string;
    public startDate: any;
    public expectationNumber: any;

    constructor(){
        this.id = '';
        this.speechTime = '';
        this.university = '';
        this.address = ''; 
        this.place = '';
        this.regulation = '';
        this.startDate = '';
        this.expectationNumber = '';
    }
}
// 新增岗位参数
class addJobFormData {
    public itineraryId: any;
    public jobName: any;
    public jobId: string;           
    public number: string;   
    public workPlace: string;
    public salary: string;
    public jobRequirements: string;
    public jobDescription: string;
    public education: any;
    constructor(){
        this.itineraryId = '';
        this.jobId = '';
        this.number = '';
        this.workPlace = ''; 
        this.salary = '';
        this.jobRequirements = '';
        this.jobDescription = '';
    }
}
// 编辑行程参数
class editJobFormData {
    public itineraryId: any;
    public id: any;
    public jobName: any;
    public jobId: string;           
    public number: string;   
    public workPlace: string;
    public salary: string;
    public jobWelfare: string;
    public jobRequirements: string;
    public jobDescription: string;
    public education: any;
    constructor(){
        this.itineraryId = '';
        this.jobName = '';
        this.education = '';
        this.id = '';
        this.jobId = '';
        this.number = '';
        this.workPlace = ''; 
        this.salary = '';
        this.jobWelfare = '';
        this.jobRequirements = '';
        this.jobDescription = '';
    }
}






export {
    searchReq,
    addFormData,
    editFormData,
    addJobFormData,
    editJobFormData

}